import React, { useState, useEffect } from "react";
import { useForm } from "react-hook-form";
import { toast } from "react-toastify";
import { makeStyles } from "@mui/styles";
import TextField from "@mui/material/TextField";
import { Autocomplete } from "@mui/lab";
import PublicWebsiteActions from "../../../Actions/PublicWebsiteActions";
import PublicWebsiteConstants from "../../../Constants/PublicWebsiteConstants";
import publicWebsiteStore from "../../../Stores/PublicWebsiteStore";
import { useGlobalSpinnerActionsContext } from "../../../Context/GlobalSpinnerContext";
import {
  useLanguageActionContext,
  useLanguageContext,
} from "../../../Context/LanguageContext";
import { _functionHelper } from "../HelperFunction/HelperFunction";

const useStyles = makeStyles((theme) => ({
  root: {
    "& .MuiTextField-root": {
      margin: theme.spacing(1),
    },
  },
  accordionWrapper: {
    marginBottom: theme.spacing(2),
  },
  accordion: {
    border: `1px solid ${theme.palette.divider}`,
    borderBottom: `1px solid ${theme.palette.divider} !important`,
    borderRadius: theme.shape.borderRadius,
    boxShadow: theme.shadows[1],
    marginBottom: theme.spacing(2),
  },
}));

const labelStyle = {
  fontSize: "14px",
  backgroundColor: "white",
};

export default function CreateTicket({
  equipmentDetails,
  setInputTitleValue,
  titleRequiredError,
  handleBlurTitle,
  setDescriptionValue,
  descriptionRequiredError,
  handleBlurDescription,
  setCategoryValue,
  categoryRequiredError,
  handleBlurCategory,
  isCreateTicketActive,
  setPriorityValue,
  priorityRequiredError,
  handleBlurPriority,
}) {
  const {
    register,
    setFocus,
    formState: { errors },
  } = useForm({ mode: "all" });
  const classes = useStyles();
  const setGlobalSpinner = useGlobalSpinnerActionsContext();
  const { language, localization } = useLanguageContext();
  const UpdateLanguage = useLanguageActionContext();
  const [selectedTitle, setSelectedTitle] = useState("");
  const [inputTitle, setInputTitle] = useState("");
  const [titleList, setTitleList] = useState([]);
  const [description, setDescription] = useState("");
  const [priority, setPriority] = useState("Low");
  const [category, setCategory] = useState("");
  const [categoryList, setCategoryList] = useState([]);

  useEffect(() => {
    if (equipmentDetails.anlagegruppeID) {
      getTitles(equipmentDetails.anlagegruppeID);
    }

    if (equipmentDetails && equipmentDetails.categories) {
      setCategoryList(equipmentDetails.categories);
    }
    return () => {};
  }, [equipmentDetails]);

  useEffect(() => {
    if (isCreateTicketActive) {
      setInputTitleValue("");
      setDescriptionValue("");
      setCategoryValue("");
      setPriorityValue("Low");
    }

    return () => {};
  }, [isCreateTicketActive]);

  useEffect(() => {
    if (category && category !== " " && category !== "") {
      setInputTitleValue(category);
      handleBlurTitle(category);
    }
  }, [category, setInputTitleValue, handleBlurTitle]);

  useEffect(() => {
    UpdateLanguage(language);
    return () => {};
  }, [language]);

  const getTitles = (equipmentGroupId) => {
    PublicWebsiteActions.GetDistinctTitles(equipmentGroupId);
  };

  const getTitleDescription = () => {
    if (selectedTitle != null && selectedTitle != "") {
      PublicWebsiteActions.GetTitleDescription(
        equipmentDetails.anlagegruppeID,
        selectedTitle
      );
    } else {
      setDescription("");
      setDescriptionValue("");
    }
  };

  useEffect(() => {
    getTitleDescription();
    return () => {};
  }, [selectedTitle]);

  useEffect(() => {
    if (description != null && description != "") {
      setFocus("faultDescription");
    }
    return () => {};
  }, [description]);

  const updateDescription = (desc) => {
    setDescription(desc);
  };

  function hanldeTitleBlur() {
    if (inputTitle === "") {
      setInputTitleValue("");
      handleBlurTitle("");
    } else {
      setInputTitleValue(inputTitle != "" ? inputTitle : selectedTitle);
      handleBlurTitle(inputTitle != "" ? inputTitle : selectedTitle);
    }
  }

  function hanldeDescriptionBlur() {
    if (description === "") {
      setDescriptionValue("");
      handleBlurDescription("");
    } else {
      setDescriptionValue(description);
      handleBlurDescription(description);
    }
  }

  function hanldeCategoryBlur() {
    if (category === "") {
      setCategoryValue("");
      handleBlurCategory("");
    } else {
      setCategoryValue(category);
      handleBlurCategory(category);
    }
  }

  function hanldePriorityBlur() {
    if (priority === "") {
      setPriorityValue("");
      handleBlurPriority("");
    } else {
      setPriorityValue(priority);
      handleBlurPriority(priority);
    }
  }

  useEffect(() => {
    function getTitleSuccess() {
      var res = publicWebsiteStore.getTitleResult();
      if (res != null && res != "" && res.length == undefined) {
        setTitleList([res.toString()]);
      } else if (res.length > 0) {
        setTitleList(res);
      }
      setGlobalSpinner(false);
    }

    function getTitleFailure() {
      var res = publicWebsiteStore.getTitleResult();
      setGlobalSpinner(false);
      toast.error(res);
    }
    publicWebsiteStore.addChangeListener(
      PublicWebsiteConstants.GET_TITLE_SUCCESS,
      getTitleSuccess
    );

    publicWebsiteStore.addChangeListener(
      PublicWebsiteConstants.GET_TITLE_FAILURE,
      getTitleFailure
    );

    return () => {
      publicWebsiteStore.removeChangeListener(
        PublicWebsiteConstants.GET_TITLE_SUCCESS,
        getTitleSuccess
      );

      publicWebsiteStore.removeChangeListener(
        PublicWebsiteConstants.GET_TITLE_FAILURE,
        getTitleFailure
      );
    };
  }, []);

  useEffect(() => {
    function getTitleDescriptionSuccess() {
      var res = publicWebsiteStore.getDescriptionResult();
      if (res) {
        updateDescription(res.description);
      }
      setGlobalSpinner(false);
    }

    function getTitleDescriptionFailure() {
      var res = publicWebsiteStore.getDescriptionResult();
      setGlobalSpinner(false);
      toast.error(res);
    }
    publicWebsiteStore.addChangeListener(
      PublicWebsiteConstants.GET_TITLE_DESCRIPTION_SUCCESS,
      getTitleDescriptionSuccess
    );

    publicWebsiteStore.addChangeListener(
      PublicWebsiteConstants.GET_TITLE_DESCRIPTION_FAILURE,
      getTitleDescriptionFailure
    );

    return () => {
      publicWebsiteStore.removeChangeListener(
        PublicWebsiteConstants.GET_TITLE_DESCRIPTION_SUCCESS,
        getTitleDescriptionSuccess
      );

      publicWebsiteStore.removeChangeListener(
        PublicWebsiteConstants.GET_TITLE_DESCRIPTION_FAILURE,
        getTitleDescriptionFailure
      );
    };
  }, []);

  return (
    <>
      <div className={classes.root + " createTicketFormContainer card"}>
        <h2 className="p-3 text-center">{localization.ticketDetails}</h2>
        {Array.isArray(categoryList) && categoryList.length > 0 && (
          <div className="row m-0">
            <TextField
              select
              className="categorySelect"
              error={categoryRequiredError}
              id="priority"
              label={localization.ticketCategory}
              fullWidth
              value={category || undefined}
              helperText={
                categoryRequiredError && localization.pleaseSelectCategory
              }
              variant="outlined"
              SelectProps={{
                native: true,
              }}
              InputLabelProps={{ style: labelStyle, shrink: true }}
              {...register("category")}
              InputProps={{ className: "categorySelect" }}
              onBlur={hanldeCategoryBlur}
              onChange={(e) => {
                setCategory(e.target.value);
              }}
            >
              <option value="">{localization.select}</option>
              {categoryList.map((cat, index) => {
                return (
                  <option key={index} value={cat}>
                    {cat}
                  </option>
                );
              })}
            </TextField>
          </div>
        )}
        {(!category || category === " " || category === "") && (
          <div className="row m-0">
            <Autocomplete
              freeSolo
              id="title"
              className="titleAutocomplete"
              value={selectedTitle}
              fullWidth
              options={titleList.map((title) => title)}
              renderInput={(params) => (
                <TextField
                  {...params}
                  label={localization.ticketTitle}
                  error={titleRequiredError}
                  helperText={titleRequiredError && localization.titleRequired}
                  margin="normal"
                  variant="outlined"
                  InputLabelProps={{ style: labelStyle }}
                  {...register("Title", {
                    required: localization.titleRequired,
                  })}
                  InputProps={{ ...params.InputProps }}
                />
              )}
              onChange={(e, newValue) => {
                setSelectedTitle(newValue);
              }}
              inputValue={inputTitle}
              onBlur={hanldeTitleBlur}
              onInputChange={(event, newInputValue) => {
                setInputTitle(newInputValue);
              }}
            />
          </div>
        )}
        <div className="row m-0">
          <TextField
            error={descriptionRequiredError}
            id="faultDescription"
            label={localization.enterDescription}
            multiline
            fullWidth
            value={description}
            variant="outlined"
            helperText={
              descriptionRequiredError && localization.descriptionRequired
            }
            InputLabelProps={{ style: labelStyle }}
            {...register("faultDescription", {
              required: localization.descriptionRequired,
            })}
            onBlur={hanldeDescriptionBlur}
            onChange={(e) => {
              setDescription(e.target.value);
            }}
          />
        </div>

        <div className="row m-0">
          <TextField
            select
            className="prioritySelect"
            error={priorityRequiredError}
            id="priority"
            label={localization.priority}
            fullWidth
            value={priority}
            helperText={priorityRequiredError && localization.priorityRequired}
            variant="outlined"
            SelectProps={{
              native: true,
            }}
            InputLabelProps={{ style: labelStyle }}
            {...register("priority", {
              required: localization.priorityRequired,
            })}
            InputProps={{ className: "prioritySelect" }}
            onBlur={hanldePriorityBlur}
            onChange={(e) => {
              setPriority(e.target.value);
            }}
          >
            <option key="low" value="Low">
              {localization.low}
            </option>
            <option key="medium" value="Medium">
              {localization.medium}
            </option>
            <option key="high" value="High">
              {localization.high}
            </option>
          </TextField>
        </div>
      </div>
    </>
  );
}
